import type { IBankIconProps } from './helpers';

export const BankIcon = ({ variant = 'default', ...rest }: IBankIconProps) => {
	if (variant === 'fund-wallet')
		return (
			<svg
				width='80'
				height='80'
				viewBox='0 0 80 80'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<path
					d='M75.0002 70.0001C75.0002 71.3807 73.8808 72.5001 72.5002 72.5001H7.50018C6.11956 72.5001 5.00018 71.3807 5.00018 70.0001C5.00018 68.6194 6.11956 67.5001 7.50018 67.5001H12.5002V45.0001H17.5002V67.5001H25.0002V45.0001H30.0002V67.5001H37.5002V45.0001H42.5002V67.5001H50.0002V45.0001H55.0002V67.5001H62.5002V45.0001H67.5002V67.5001H72.5002C73.8808 67.5001 75.0002 68.6194 75.0002 70.0001ZM5.14178 37.8699C3.95892 35.0147 4.58148 31.8824 6.76776 29.6973C6.86053 29.6033 6.96185 29.5179 7.06927 29.4398L34.1213 9.84748C37.3134 6.80915 42.7028 6.82379 45.8791 9.84748L72.9311 29.4398C73.0385 29.5179 73.1398 29.6033 73.2326 29.6973C75.4189 31.8824 76.0414 35.0147 74.8586 37.8699C73.6757 40.7264 71.0207 42.5001 67.9286 42.5001H12.0717C8.97967 42.5001 6.32464 40.7264 5.14178 37.8699ZM30.0002 27.5001C30.0002 28.8807 31.1196 30.0001 32.5002 30.0001H47.5002C48.8808 30.0001 50.0002 28.8807 50.0002 27.5001C50.0002 26.1194 48.8808 25.0001 47.5002 25.0001H32.5002C31.1196 25.0001 30.0002 26.1194 30.0002 27.5001Z'
					fill='#05A2BF'
				/>
			</svg>
		);

	return (
		<svg
			width='120'
			height='121'
			viewBox='0 0 120 121'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...rest}
		>
			<g clipPath='url(#clip0_4910_122545)'>
				<path
					d='M111.334 51.0427H111.203H10.499L60.9147 19.0977L68.0828 23.6994H68.0889C67.6703 25.198 67.4489 26.7784 67.4489 28.4073C67.4489 38.1779 75.4178 46.1438 85.1824 46.1438C89.5928 46.1438 93.6337 44.518 96.746 41.8363L111.334 51.0427Z'
					fill='#E4E8EB'
				/>
				<path
					d='M111.203 51.043V61.3566H106.957H93.0028H87.8461H73.8921H47.8045H34.154H28.9971H15.0433H10.4932V51.043H10.499H111.203Z'
					fill='#CAD0D7'
				/>
				<path
					d='M106.956 61.3555V65.9056H103.922H96.0355H93.002V61.3555H106.956Z'
					fill='#E4E8EB'
				/>
				<path
					d='M96.0361 65.9062H103.923V110.498H96.0361V65.9062Z'
					fill='#CAD0D7'
				/>
				<path
					d='M96.7454 41.8361C93.6331 44.5178 89.5922 46.1437 85.1818 46.1437C75.4172 46.1437 67.4482 38.1777 67.4482 28.4071C67.4482 26.7782 67.6697 25.1978 68.0883 23.6992C70.1569 16.2067 77.0459 10.6797 85.1818 10.6797C94.9465 10.6797 102.918 18.6395 102.918 28.4071C102.918 33.767 100.519 38.5811 96.7454 41.8361Z'
					fill='#FDCD56'
				/>
				<path
					d='M96.0355 65.9056V110.497H84.8115V65.9056H87.8453V61.3555H93.002V65.9056H96.0355Z'
					fill='#636C77'
				/>
				<path
					d='M87.8456 61.3555V65.9056H84.8118H76.9251H73.8916V61.3555H87.8456Z'
					fill='#E4E8EB'
				/>
				<path
					d='M76.9248 65.9062H84.8115V110.498H76.9248V65.9062Z'
					fill='#CAD0D7'
				/>
				<path
					d='M76.9251 65.9056V110.497H71.4649V81.9831H50.534V110.497H44.7705V65.9056H47.804V61.3555H73.8916V65.9056H76.9251Z'
					fill='#636C77'
				/>
				<path
					d='M50.5342 81.9844H71.465V110.499H50.5342V81.9844Z'
					fill='#424852'
				/>
				<path
					d='M64.7311 4.35547C66.8365 4.35547 68.5472 6.0725 68.5472 8.17156C68.5472 10.2798 66.8365 11.9877 64.7311 11.9877C62.6321 11.9877 60.915 10.2798 60.915 8.17156C60.9148 6.07227 62.6321 4.35547 64.7311 4.35547Z'
					fill='#F76C82'
				/>
				<path
					d='M47.8038 61.3555V65.9056H44.7703H37.1866H34.1533V61.3555H47.8038Z'
					fill='#E4E8EB'
				/>
				<path
					d='M37.1865 65.9062H44.7702V110.498H37.1865V65.9062Z'
					fill='#CAD0D7'
				/>
				<path
					d='M37.1866 65.9056V110.497H25.9629V65.9056H28.9964V61.3555H34.1534V65.9056H37.1866Z'
					fill='#636C77'
				/>
				<path
					d='M28.9967 61.3555V65.9056H25.9632H18.0763H15.043V61.3555H28.9967Z'
					fill='#E4E8EB'
				/>
				<path
					d='M18.0762 65.9062H25.9631V110.498H18.0762V65.9062Z'
					fill='#CAD0D7'
				/>
				<path
					d='M111.203 108.965H80.869H71.4654H50.5345H40.8274H10.4932C9.65555 108.965 8.97656 109.651 8.97656 110.488C8.97656 111.326 9.65531 112.012 10.4932 112.012H40.8277H50.5348H71.4656H80.8692H111.204C112.041 112.012 112.721 111.326 112.721 110.488C112.721 109.651 112.041 108.965 111.203 108.965Z'
					fill='#424852'
				/>
				<path
					d='M111.203 117.475H10.4932C9.65555 117.475 8.97656 116.796 8.97656 115.958C8.97656 115.12 9.65531 114.441 10.4932 114.441H111.203C112.041 114.441 112.72 115.12 112.72 115.958C112.72 116.796 112.041 117.475 111.203 117.475Z'
					fill='#424852'
				/>
				<path
					d='M18.6826 34.3577H11.0989C10.2613 34.3577 9.58203 33.6785 9.58203 32.8409C9.58203 32.0032 10.261 31.3242 11.0989 31.3242H18.6823C19.52 31.3242 20.1992 32.0032 20.1992 32.8409C20.1992 33.6785 19.5202 34.3577 18.6826 34.3577Z'
					fill='#424852'
				/>
				<path
					d='M15.043 38C14.2054 38 13.5264 37.3208 13.5264 36.4831V28.8997C13.5264 28.062 14.2051 27.3828 15.043 27.3828C15.8809 27.3828 16.5599 28.062 16.5599 28.8997V36.4831C16.5596 37.3208 15.8807 38 15.043 38Z'
					fill='#424852'
				/>
				<path
					d='M118.484 75.3111H110.597C109.759 75.3111 109.08 74.6321 109.08 73.7942C109.08 72.9563 109.759 72.2773 110.597 72.2773H118.484C119.321 72.2773 120.001 72.9563 120.001 73.7942C120.001 74.6321 119.322 75.3111 118.484 75.3111Z'
					fill='#424852'
				/>
				<path
					d='M114.539 79.2539C113.702 79.2539 113.022 78.5749 113.022 77.737V70.1536C113.022 69.3159 113.701 68.6367 114.539 68.6367C115.377 68.6367 116.056 69.3157 116.056 70.1536V77.737C116.056 78.5749 115.377 79.2539 114.539 79.2539Z'
					fill='#424852'
				/>
				<path
					d='M9.15779 106.669C8.7699 106.669 8.38178 106.521 8.08576 106.226L0.444903 98.5937C-0.147832 98.0019 -0.148301 97.0415 0.443496 96.4487C1.03482 95.8565 1.99506 95.8553 2.58826 96.4473L10.2298 104.08C10.8223 104.672 10.8226 105.632 10.2308 106.225C9.93475 106.521 9.54615 106.669 9.15779 106.669Z'
					fill='#424852'
				/>
				<path
					d='M1.5167 106.67C1.12811 106.67 0.739746 106.521 0.443496 106.225C-0.148301 105.632 -0.147832 104.672 0.444903 104.08L8.08576 96.4478C8.67826 95.8558 9.6385 95.8558 10.2308 96.4487C10.8226 97.0412 10.8223 98.0017 10.2298 98.5938L2.58826 106.226C2.29201 106.522 1.90436 106.67 1.5167 106.67Z'
					fill='#424852'
				/>
				<path
					d='M116.675 106.299C116.286 106.299 115.898 106.15 115.602 105.853L107.97 98.2093C107.378 97.6166 107.379 96.6561 107.971 96.0643C108.565 95.4725 109.525 95.4737 110.116 96.0659L117.748 103.711C118.34 104.303 118.34 105.263 117.747 105.855C117.451 106.151 117.063 106.299 116.675 106.299Z'
					fill='#424852'
				/>
				<path
					d='M109.043 106.303C108.655 106.303 108.267 106.155 107.971 105.859C107.379 105.267 107.378 104.307 107.97 103.715L115.602 96.07C116.193 95.4775 117.154 95.4763 117.747 96.0684C118.34 96.6602 118.34 97.6206 117.748 98.2134L110.116 105.857C109.82 106.154 109.432 106.303 109.043 106.303Z'
					fill='#424852'
				/>
			</g>
			<defs>
				<clipPath id='clip0_4910_122545'>
					<rect
						width='120'
						height='120'
						fill='white'
						transform='translate(0 0.914062)'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};
